<!-- 
<div class="loader-overlay d-flex justify-content-center align-items-center">
  <img src="assets/images/loader.gif" alt="Loading..." style="width: 100px;display:flex; justify-content:center; align-items:center" />
</div> -->
<div class="loader-overlay">
  <img src="assets/images/loader.gif" alt="Loading..." />
</div>
